import { type ReactNode } from 'react';
import { Typography, type TypographyProps } from '@mui/material';

interface CardTitleProps extends Omit<TypographyProps, 'variant'> {
  children: ReactNode;
}

export function CardTitle({ children, className, ...props }: CardTitleProps) {
  return (
    <Typography
      variant="h6"
      component="h3"
      className={`font-semibold ${className || ''}`}
      {...props}
    >
      {children}
    </Typography>
  );
}
